/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2023, Zumper
 */

import type { Location } from 'history'
import { PREVIOUS_LOCATION } from './trackPreviousLocationInHistoryState'

export const isLocation = (
  location: unknown
): location is Location<unknown> => {
  return (
    typeof location === 'object' &&
    !!location &&
    'pathname' in location &&
    typeof location.pathname === 'string' &&
    'hash' in location &&
    typeof location.hash === 'string' &&
    'search' in location &&
    typeof location.search === 'string' &&
    'state' in location
  )
}

export const getPreviousLocation = (
  location: Location<unknown>
): Location<unknown> | undefined => {
  if (
    typeof location.state === 'object' &&
    location.state &&
    PREVIOUS_LOCATION in location.state &&
    typeof location.state[PREVIOUS_LOCATION] === 'object' &&
    isLocation(location.state[PREVIOUS_LOCATION])
  ) {
    return location.state[PREVIOUS_LOCATION]
  }
}
